import React from "react";

const ScrollableContainer = ({ children, className = "", direction = "x" }) => {
  return (
    <div
      className={`w-full ${
        direction === "x"
          ? "overflow-x-scroll scrollbar-hide flex gap-fluid-1"
          : "overflow-y-auto scrollbar-hide space-y-fluid-1"
      } scroll-smooth scroll-snap-${
        direction === "x" ? "x" : "y"
      } mandatory p-fluid-1 ${className}`}
      style={{
        scrollPadding: direction === "x" 
          ? '0 clamp(0.5rem, 1.0vw, 1rem)' 
          : 'clamp(0.5rem, 1.0vw, 1rem) 0',
        scrollbarGutter: 'stable'
      }}
    >
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          className: `${
            direction === "x" 
              ? "flex-[0_0_auto] snap-start" 
              : "snap-start"
          } ${child.props.className || ""}`
        })
      )}
    </div>
  );
};

export default ScrollableContainer;